import { Icon } from '@iconify/react';
import pieChart2Fill from '@iconify/icons-eva/pie-chart-2-fill';
import gridFill from '@iconify/icons-eva/grid-fill';
import squreFill from '@iconify/icons-eva/square-fill';

// ----------------------------------------------------------------------

const getIcon = (name) => <Icon icon={name} width={22} height={22} />;

const sidebarConfig = [
  {
    title: 'dashboard',
    path: '/dashboard/app',
    icon: getIcon(pieChart2Fill)
  },
  {
    title: 'Groups',
    path: '/dashboard/groups',
    icon: getIcon(squreFill)
  },
  {
    title: 'Devices',
    path: '/dashboard/devices',
    icon: getIcon(gridFill)
  }
];

export default sidebarConfig;
